import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/@core/services/app/app.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-global-infra',
  templateUrl: './global-infra.component.html',
  styleUrls: ['./global-infra.component.scss'],
})
export class GlobalInfraComponent implements OnInit, OnDestroy {
  @Input() organization: Organization;
  @Input() orgDelete: string;

  infra: Infrastructure;
  subscription: Subscription;
  
  constructor(
    public infraService: InfrastructureService,
    private readonly router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private appService: AppService,
    public darkModeService: DarkModeService
  ) { }

  ngOnInit() {  
    this.subscription = this.infraService.currentInfra.subscribe(infra => {
      this.infra = infra;
    });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
  
  deleteOrganization() {
    const ok: (orgDelete?: String) => void = (organization) => {
      const loading = this.appService.openLoading();
      this.infra.organizations.forEach ((org) => {
        if( org.name === organization){
          this.infraService.deleteOrganizationInfra(org).subscribe(() => {
            const msg = this.translate.instant('ORG_ADMIN.ORG_DELETED');
            this.snackBar.open(msg, null, { duration: 5000 });
            this.infraService.refreshGlobalStatus();
            loading.close();
          });
        }
      });  
    }
    this.translate.get(['ALERT.SURE_DELETE', 'ALERT.CONFIRM-DELETE']).subscribe(values => {
      this.appService.openDialogDeleteOrganization(values['ALERT.SURE_DELETE'], values['ALERT.CONFIRM-DELETE'], this.infra, ok, () => { });
    });
  }

  navigateToCreateOrganization() {
    this.router.navigate(['/v1/organization']);
  }

}
